import React, { ReactElement } from 'react';
import { Lock, Plus } from '@menuzen/icon/build/outline';
import classNames from 'classnames';

interface BlockCardProps {
    image?: string;
    icon?: ReactElement;
    title: string;
    subTitle?: string;
    isReady?: boolean;
    forGrowAccount?: boolean;
    onClickAdd?: () => void;
    reachLimits?: boolean;
}

const NewBlockCard: React.FC<BlockCardProps> = ({
    image,
    icon,
    title,
    subTitle,
    isReady,
    forGrowAccount,
    onClickAdd,
    reachLimits,
}) => {
    return (
        <div
            className={classNames({
                'rounded-8': true,
                'bg-gradient-dark p-1': forGrowAccount,
                'bg-white': !forGrowAccount,
                'opacity-50': reachLimits,
                'cursor-not-allowed': reachLimits || !isReady,
                'cursor-pointer': isReady && !reachLimits,
            })}
        >
            <div
                className={classNames({
                    'relative flex items-center justify-center rounded-8 py-10 px-12': true,
                    'bg-gradient-mid': forGrowAccount,
                    'bg-white border border-primary-40': !forGrowAccount,
                })}
                onClick={() => {
                    if (isReady && onClickAdd) {
                        onClickAdd();
                    }
                }}
            >
                {!isReady && (
                    <div className="z-10 absolute top-0 left-0 rounded-tl-8 py-4 px-6 bg-primary-20 text-10 leading-13 font-semibold">
                        COMING SOON
                    </div>
                )}
                {icon && (
                    <div className="flex-shrink-1 rounded-5 bg-started h-50 w-50 flex items-center justify-center text-24">
                        {icon}
                    </div>
                )}
                {image && (
                    <div className="relative flex-shrink-1 rounded-5 bg-started h-50 w-50 flex items-center justify-center text-24">
                        <img src={image} className="absolute bottom-0 w-42" />
                    </div>
                )}
                <div className="flex-grow mx-8">
                    <div className="text-14 leading-16">{title}</div>
                    {subTitle && <div className="mt-2 text-10 leading-12 text-primary-70">{subTitle}</div>}
                </div>
                {isReady ? (
                    <div
                        className={classNames({
                            'h-24 w-24 bg-teal text-white text-16 rounded-full flex items-center justify-center': true,
                        })}
                    >
                        <Plus />
                    </div>
                ) : (
                    <div className="h-24 w-24 bg-primary-10 text-primary-80 text-16 rounded-full flex items-center justify-center">
                        <Lock />
                    </div>
                )}
            </div>
        </div>
    );
};

export default NewBlockCard;
